import { makeAutoObservable } from "mobx";
import { create, persist } from 'mobx-persist'
import { message } from "antd";
import { generateQuestion, getBookInfo } from "../utils/request";


async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    // 可以添加成功提示
    message.success('复制成功');
  } catch (err) {
    // 处理错误
    message.error('复制失败');
    console.error('复制失败:', err);
  }
}

// Todo 用户信息
class BookStore {
  loading = false
  prompt = ""
  questionJson = ""
  showPromptModal = false
  questions = Array.from({ length: 8 }, () => ({
    title: "",
    remark: "",
    options: [{ text: "" }, { text: "" }, { text: "" }, { text: "" }],
    correctValue: "",
    questionType: "",
  }))
  activeQuestionKey = 0

  questionTypes = [
    { value: 'Information Retrieval 资讯检索' },
    { value: 'Inferences 推论信息' },
    { value: 'Interpretation 解释和整合' },
    { value: 'Evaluation评估' }
  ]

  // 每个问题的加载状态
  questionLoadingStates = Array(12).fill(false)

  // 新增 bookInfo 相关状态
  bookInfo = {
    id: undefined,
    title: "",
    cover: "",
    content: "",
    category: "",
    subcategory: [],
    classes: [],
    filePath: ""
  }

  // AI 文本相关状态
  aiContent = ""

  constructor() {
    makeAutoObservable(this);
  }

  getBookInfo(id) {
    getBookInfo(id).then(res => {
      this.bookInfo = res.data;
    });
  }

  isInvalid(val) {
    return val === undefined || val === null || val === "";
  }

  async validateActiveQuestion() {
    const currentQuestion = this.questions[this.activeQuestionKey];
    if (!currentQuestion) return true;

    if (this.isInvalid(currentQuestion.correctValue)) {
      message.warning("请选择正确答案");
      return false;
    }
    return true;
  }

  validateQuestion(question, index) {
    if (!question.title) {
      message.warning("题目不可为空");
      return false;
    }

    if (question.options.findIndex(o => !o.text) !== -1) {
      message.warning(`题目${index + 1}选项不可为空`);
      return false;
    }
    if (question.correctValue === "") {
      message.warning(`请选择题目${index + 1}的正确答案`);
      return false;
    }
    return true;
  }

  async validateAllQuestions() {
    for (let i = 0; i < this.questions.length; i++) {
      if (!this.validateQuestion(this.questions[i], i)) {
        this.activeQuestionKey = i;
        return false;
      }
    }
    return true;
  }

  async changeTab(newKey) {
    // const isValid = await this.validateActiveQuestion();
    // if (!isValid) return false;
    this.setActiveKey(newKey);
    return true;
  }

  setQuestions(questions) {
    this.questions = questions;
  }

  setQuestionLoading(index, loading) {
    this.questionLoadingStates[index] = loading;
  }

  // 更新 bookInfo
  updateBookInfo(updates) {
    this.bookInfo = {
      ...this.bookInfo,
      ...updates
    };
  }

  // 设置 AI 内容
  setAIContent(content) {
    this.aiContent = content;
  }

  // 验证 bookInfo
  validateBookInfo() {
    if (!this.bookInfo.cover) {
      message.warning("书籍封面不可为空");
      return false;
    }
    if (!this.bookInfo.title) {
      message.warning("书籍名称不可为空");
      return false;
    }
    if (!this.bookInfo.subcategory.length) {
      message.warning("书籍类目不可为空");
      return false;
    }
    if (!this.bookInfo.classes.length) {
      message.warning("书籍可见班级不可为空");
      return false;
    }
    return true;
  }

  // AI 生成问题
  async generateQuestionByAI(index) {
    if (!this.bookInfo.title) {
      message.warning('请先填写书名');
      return;
    }

    if (!this.questions[index].questionType) {
      message.warning('请选择题目类型');
      return;
    }

    try {
      this.setQuestionLoading(index, true);
      const result = await generateQuestion({
        bookId: this.bookInfo.id,
        title: this.bookInfo.title,
        category: this.bookInfo.category,
        filePath: this.bookInfo.filePath,
        content: this.aiContent,
        questionType: this.questions[index].questionType
      });

      if (result) {
        this.updateQuestionField(index, {
          title: result.data.question,
          remark: result.data.explanation,
          options: [
            { text: result.data.answerList[0] },
            { text: result.data.answerList[1] },
            { text: result.data.answerList[2] },
            { text: result.data.answerList[3] }
          ],
          correctValue: result.data.correctAnswerIndex
        });
      }
      return result;
    } catch (error) {
      console.error(error);
      return null;
    } finally {
      this.setQuestionLoading(index, false);
    }
  }

  updateQuestionField(index, values) {
    this.questions[index] = {
      ...this.questions[index],
      ...values
    };
  }

  setActiveKey(key) {
    this.activeQuestionKey = Number(key);
  }

  addQuestion() {
    if (this.questions.length >= 12) {
      message.warning('题目数量不能超过12个');
      return;
    }
    this.questions.push({
      title: "",
      remark: "",
      options: [{ text: "" }, { text: "" }, { text: "" }, { text: "" }],
      correctValue: "",
      questionType: "",
    });
    this.setActiveKey(this.questions.length - 1);
  }

  handleQuestionJsonChange = (e) => {
    console.log(e)
    this.questionJson = e.target.value
  }

  handleQuestionJsonSubmit() {
    try {
      const questionJson = JSON.parse(this.questionJson)
      console.log(questionJson.answerList)
      this.updateQuestionField(this.activeQuestionKey, {
        title: questionJson.question,
        remark: questionJson.explanation,
        options: questionJson.answerList.map(item => ({ text: item })),
        correctValue: questionJson.correctAnswerIndex
      })
      this.showPromptModal = false
      this.questionJson = ""
    } catch (e) {
      message.error("解析失败，请确认数据格式")
    }
  }

  handleDeepSeek(index) {
    if (!this.bookInfo.title) {
      message.warning('请先填写书名');
      return;
    }

    if (!this.questions[index].questionType) {
      message.warning('请选择题目类型');
      return;
    }

    const title = this.bookInfo.title
    const category = this.bookInfo.category
    const questionType = this.questions[index].questionType

    this.prompt = `你是一个小学老师，现在需要你先根据附件去读取书籍内容，再分析，然后给小学生出题。请不要凭空编造内容。请避免出重复的题。请一步一步思考。

    题目分为四种类型：
    1. Information Retrieval 资讯检索 (在文中找到明确的信息)。请用直接明确的信息，不要出"为什么"一类的推论问题
    2. Inferences 推论信息 （将多个信息或线索串联，进行简单的推论，像是找出事件发生的原因，或是两个角色之间的关联）
    3. Interpretation 解释和整合 (整合文章中所有讯息，归纳整合文章的观点、信息和主题) 
    4. Evaluation评估 （对文章内容、文本语言、文本类型、内容观点等进行个人评估）。在此类目下请不要用"什么道理" "什么主题"出题

    本次书名为：《${title}》
    出题类型是：${questionType}

    请你根据选择的类型出一个对应的题目，这个题目有四个不同的选项，并且给出正确答案和相应的解释。
    书籍的语言类型为${category || '中文书'}，需要用对应的语言出题。

    请你根据如下例子（以中文书为例）返回对应的JSON格式数据：
    {
      "question": "在《Floppy the Hero》这本书中，Floppy在森林里救了谁？",
      "answerList": ["一只小猫", "一只小鸟", "一只小狗", "一只小兔子"],
      "correctAnswerIndex": 3,
      "explanation": "在书中第7页有一段描述Floppy在森林中发现了一只被困的小兔子，并成功地将它救出。这是Floppy成为英雄的重要情节之一。"
    }
    
    返回的explanation请尽量明确指出答案依据在书中第几页。直接返回JSON数据即可，不需要其他多余文字，以确保我可以直接使用JSON.parse(message)来解析。注意：所有属性名和字符串值都必须使用双引号包裹。`

    copyToClipboard(this.prompt)
    this.showPromptModal = true

  }



  removeQuestion(targetKey) {
    if (this.questions.length <= 8) {
      message.warning('题目数量不能少于8个');
      return;
    }

    const targetIndex = Number(targetKey);
    this.questions.splice(targetIndex, 1);

    if (this.activeQuestionKey >= this.questions.length) {
      this.activeQuestionKey = this.questions.length - 1;
    }
  }
}

const schema = {
  profile: 'object'
}


const hydrate = create({
  storage: localStorage,   // or AsyncStorage in react-native.
  jsonify: true  // if you use AsyncStorage, here shoud be true
})

const bookStore = persist(schema)(new BookStore())

hydrate('bookStore', bookStore).then(() => console.log('bookStore has been hydrated'))

export default bookStore;

